import { render, staticRenderFns } from "./fechamento_parcial.vue?vue&type=template&id=db8fcdc0&"
import script from "./fechamento_parcial.vue?vue&type=script&lang=js&"
export * from "./fechamento_parcial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports